import React, { memo, useCallback, useMemo } from 'react'

import { EditableArea } from 'core/components/shared/ui/EditableArea'

import { ILocationTree, LocationTree as StageLocationTree } from './LocationTree'

export const LocationTreeExtended = memo((props: ILocationTree) => {
  const { partnerTerritory } = props
  const allCountriesCodeToNameMapping = useMemo(() => {
    const mapping: Record<string, string> = {}
    partnerTerritory.countries.forEach((country) => {
      mapping[country.value] = country.name
    })

    return mapping
  }, [partnerTerritory.countries])

  const getNamesByCodes = useCallback(
    (countryCodes: string[]) => {
      return countryCodes.map((code) => allCountriesCodeToNameMapping[code]).filter(Boolean)
    },
    [allCountriesCodeToNameMapping]
  )

  const selectedCountriesNames = useMemo(() => {
    const names = props.value ? getNamesByCodes(props.value) : []

    return names.length ? names.join(' / ') : ''
  }, [props.value, getNamesByCodes])

  return (
    <div
      style={{
        marginBottom: '16px',
      }}
    >
      <StageLocationTree {...props} partnerTerritory={partnerTerritory} />
      <EditableArea text={selectedCountriesNames} multiline disabled />
    </div>
  )
})
